export const environment = {
  production: true,
  apiBase: 'https://rest.bhavani.app',
};
